// CategoryProducts.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft, Grid, List, Search, ShoppingBag, Package, Heart, Star } from 'lucide-react';
import './CategoryProducts.css';
import CategorySlider from './CategorySider';
import CategorySider from './CategorySider';

const CategoryProducts = ({searchTerm,setSearchTerm}) => {
  const { categoryId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [viewMode, setViewMode] = useState('grid');
  // const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('name');

  const categoryName = location.state?.categoryName || 'Category';

  const fetchProductsByCategory = async () => {
    try {
      setLoading(true);
      setError(null);

      const apiUrl = `${process.env.REACT_APP_BASE_URL}/products/category/${categoryId}`;
      console.log('Fetching products from:', apiUrl);

      const response = await fetch(apiUrl);

      if (!response.ok) {
        let errorMessage = `Failed to fetch products (${response.status})`;
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
        } catch (e) {
          errorMessage = response.statusText || errorMessage;
        }
        throw new Error(errorMessage);
      }

      const data = await response.json();

      if (data.success) {
        setProducts(data.data || []);
      } else {
        throw new Error(data.message || 'Failed to fetch products');
      }
    } catch (err) {
      setError(err.message || 'Error connecting to server');
      console.error('Error fetching products:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (categoryId) {
      fetchProductsByCategory();
    } else {
      setError('No category ID provided');
      setLoading(false);
    }
  }, [categoryId]);

  const getImageUrl = (product) => {
    if (product.images && product.images.length > 0) {
      const imagePath = product.images[0].path;

      if (!imagePath) return null;
      if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
      }

      const path = imagePath.startsWith('/') ? imagePath.substring(1) : imagePath;
      const baseUrl = process.env.REACT_APP_BASE_URL.split('/api')[0];
      return `${baseUrl}/${path}`;
    }

    if (product.imageUrl) {
      const imagePath = product.imageUrl;

      if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
      }

      const path = imagePath.startsWith('/') ? imagePath.substring(1) : imagePath;
      const baseUrl = process.env.REACT_APP_BASE_URL.split('/api')[0];
      return `${baseUrl}/${path}`;
    }

    return null;
  };

  const getFilteredAndSortedProducts = () => {
    let filtered = products.filter(product =>
      product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.description?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    switch (sortBy) {
      case 'name':
        filtered.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case 'price-low':
        filtered.sort((a, b) => a.price - b.price);
        break;
      case 'price-high':
        filtered.sort((a, b) => b.price - a.price);
        break;
      case 'newest':
        filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        break;
      default:
        break;
    }

    return filtered;
  };

  const filteredProducts = getFilteredAndSortedProducts();

  const handleProductClick = (productId) => {
    navigate(`/products/${productId}`);
  };

  if (loading) {
    return (
      <div className="category-products-container">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p className="loading-text">Loading products...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="category-products-container">
        <div className="error-container">
          <Package className="error-icon" />
          <h3>Error Loading Products</h3>
          <p>{error}</p>
          <div className='errorBtn'>
            <button className="error-retry-btn" onClick={fetchProductsByCategory}>
              Try Again
            </button>
            <button
              className="error-retry-btn"
              onClick={() => navigate('/')}
            >
              Go Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="category-page-layout">
      <div className="category-sideba0r sidebar-large">
        <CategorySider />
      </div>
      <div className="category-products-container">
        <div className="category-products-header">
          {/* <button className="back-button" onClick={() => navigate(-1)}>
          <ArrowLeft size={20} />
          <span>Back</span>
        </button> */}

          <div className="header-content">
            <h1 className="category-title">{categoryName}</h1>
            <p className="products-count">
              {filteredProducts.length} {filteredProducts.length === 1 ? 'product' : 'products'} found
            </p>
          </div>
        </div>

        <div className="products-controls">
          {/* <div className="search-container">
          <Search className="search-icon" size={20} />
          <input
            type="text"
            placeholder="Search products..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="Categsearch-input"
          />
        </div> */}

          {/* <div className="controls-right"> */}
          {/* <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="sort-select"
          >
            <option value="name">Sort by Name</option>
            <option value="price-low">Price: Low to High</option>
            <option value="price-high">Price: High to Low</option>
            <option value="newest">Newest First</option>
          </select> */}

          {/* <div className="view-mode-buttons">
            <button
              className={`view-mode-btn ${viewMode === 'grid' ? 'active' : ''}`}
              onClick={() => setViewMode('grid')}
              title="Grid View"
            >
              <Grid size={20} />
            </button>
            <button
              className={`view-mode-btn ${viewMode === 'list' ? 'active' : ''}`}
              onClick={() => setViewMode('list')}
              title="List View"
            >
              <List size={20} />
            </button>
          </div> */}
          {/* </div> */}
        </div>

        {filteredProducts.length > 0 ? (
          <div className={`products-grid ${viewMode}`}>
            {filteredProducts.map((product) => (
              <div key={product._id} className="product-card-modern">
                {/* Best Seller Badge */}
                {product.isBestSeller && (
                  <div className="badge-bestseller">
                    <span>Best Seller</span>
                  </div>
                )}

                {/* Wishlist Button */}
                {/* <button className="wishlist-btn" onClick={(e) => e.stopPropagation()}>
                  <Heart size={20} />
                </button> */}

                {/* Product Image */}
                <div className="product-image-wrapper" onClick={() => handleProductClick(product._id)}>
                  <img
                    src={getImageUrl(product) || '/api/placeholder/300/300'}
                    alt={product.name}
                    className="product-image-modern"
                    onError={(e) => {
                      e.target.src = '/api/placeholder/300/300';
                    }}
                  />
                  {product.quantity === 0 && (
                    <div className="out-of-stock-badge">Out of Stock</div>
                  )}
                </div>

                {/* Product Info */}
                <div className="product-info-modern">
                  <p className="product-category-label">{product.category}</p>
                  <h3 className="product-name-modern">{(product.name).slice(0, 15) + "..."}</h3>
                  <p className="product-description-modern">
                    {product.description?.substring(0, 60)}
                    {product.description?.length > 60 ? '...' : ''}
                  </p>

                  {/* Rating */}
                  <div className="product-rating">
                    <Star size={16} fill="#fbbf24" color="#fbbf24" />
                    <span className="rating-value">4.0</span>
                  </div>

                  {/* Price */}
                  <div className="product-price-section">
                    <span className="product-price-modern">₹{product.finalPrice || product.price}</span>
                    {product.discountPercentage > 0 && (
                      <span className="product-price-original">₹{product.price}</span>
                    )}
                  </div>

                  {/* View Details Button */}
                  <button
                    className="view-details-btn"
                    onClick={() => handleProductClick(product._id)}
                  >
                    <span>View Details</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-products-state">
            <ShoppingBag className="empty-icon" size={64} />
            <h3>No Products Found</h3>
            <p>
              {searchTerm
                ? `No products match "${searchTerm}" in this category.`
                : 'No products available in this category yet.'}
            </p>
            {searchTerm && (
              <button
                className="clear-search-btn"
                onClick={() => setSearchTerm('')}
              >
                Clear Search
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryProducts;